module.exports = __webpack_public_path__ + "static/media/img2.f3b60671.jpg";